import { AlertModal, DisplayValue } from '../../..'
import { observer } from 'mobx-react-lite'
import { Icons } from '../../../misc/Icons'
import { store } from '../../../stores/Store'
import PanelBody from '../../layout/PanelBody'
import PanelHeader from '../../layout/PanelHeader'
import { Button, IconButton } from '@mui/material'
import ViewQuestionnaire from './ViewQuestionnaire'
import QuestionnaireTable from './QuestionnaireTable'
import ErrorBoundary from '../../../misc/ErrorBoundary'
import CreateQuestionnaireForm from './CreateQuestionnaireForm'
import QuestionnaireImportForm from './QuestionnaireImportForm'
import React from 'react'
import QuestionnaireSettingsForm from './QuestionnaireSettingsForm'


export default observer(function QuestionnaireTool () {        

    const { sessionInfo, readOnly, checkJwtRole, checkJwtRoles } = store.AppStore
    const { getQuestionnaires, searchString, setSearchString, setSearchTemplateKeys, setSearchAccountUids } = store.QuestionnaireStore

    var userAccountUid = sessionInfo.userAccount?.uid
    var account = store.NodeStore.accounts.find(a => a.uid === userAccountUid)
    var questionnairesEnabled = !!account?.advisorUid

    React.useEffect(() => {
        setSearchTemplateKeys(null)
        setSearchAccountUids(null)
        setSearchString("")
    }, [])

    return (
        <ErrorBoundary>
            <div className="panel panel-dark">
                <PanelHeader>
                    <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                        <h2>Questionnaires</h2>
                        
                        {questionnairesEnabled ? (
                            <>
                                <div>
                                    <div className="form-search form-search-dark">
                                        <input 
                                            autoFocus 
                                            value={searchString}
                                            placeholder="Search"
                                            spellCheck="false"
                                            onChange={(e) => {
                                                setSearchString(e.target.value)
                                            }} />
                                        
                                        {/* <Button
                                            color="secondary"
                                            className="btn btn-sm"
                                            onClick={() => getQuestionnaires()}>
                                            <Icons.Refresh style={{color: "white"}} />
                                        </Button> */}
                                    </div>
                                </div>

                                <Button
                                    color="secondary"
                                    variant="contained"
                                    className="btn btn-sm"
                                    onClick={() => getQuestionnaires()}>
                                    <Icons.Refresh /> Refresh
                                </Button>

                                {checkJwtRole("sysuser") ? (
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        className="btn btn-sm"
                                        onClick={() => AlertModal({body: <QuestionnaireImportForm />, width: "550px"})}>
                                        Import
                                    </Button>
                                ) : null}

                                {!readOnly ? (
                                    <Button
                                        color="success"
                                        variant="contained"
                                        className="btn btn-sm"
                                        onClick={() => AlertModal({body: <CreateQuestionnaireForm />, width: "550px"})}>
                                        Create
                                    </Button>
                                ) : null}
                            </>
                        ) : null}
                    </div>
                    
                    <IconButton color="info" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
                </PanelHeader>
                
                <PanelBody>
                    {questionnairesEnabled ? (
                        <QuestionnaireTable onRowClick={(uid) => AlertModal({width: "700px", body: <ViewQuestionnaire uid={uid} />})} />
                    ) : (
                        <p>Questionnaires are not enabled for your account.</p>
                    )}
                </PanelBody>
            </div>
        </ErrorBoundary>
    )
})